import { Component, OnInit } from '@angular/core';
import { AgentService } from 'src/app/agent/services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentApplicationStatusHandlerComponent } from './agent-application-status.handler';
import { Router } from '@angular/router';

@Component({
  selector: 'sym-agent-application-status',
  templateUrl: './agent-application-status.component.html',
  styleUrls: ['./agent-application-status.component.scss'],
})
export class AgentApplicationStatusComponent extends AgentApplicationStatusHandlerComponent implements OnInit {
  constructor(agentService: AgentService, public settingService: SettingService, public router: Router) {
    super(agentService, settingService, router);
  }
}
